import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const returnTo = location.pathname + location.search + location.hash;
      // Preserve the current location state when redirecting to login
      const currentState = location.state;
      window.history.replaceState(currentState, '', returnTo);
      loginWithRedirect({ appState: { returnTo, state: currentState } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location]);

  if (isLoading || !isAuthenticated) return null; // or a spinner
  return <Outlet />;
};

export default ProtectedRoute;
